import apiClient from "./client";

export const getAdminContactUsRequests = async () => {
  const response = await apiClient.get("/contact-us/admin");
  return response.data;
};

export const deleteAdminContactUsRequest = async ({ id }) => {
  await apiClient.delete(`/contact-us/admin/${id}`);
};
